export const FALLBACK_FONT_CACHE_NAME = 'x-design-editor-fallback-font-manager-v1';
export const FALLBACK_FONT_CACHE_PREFIX = '/__x-design-editor-font-cache__/fallback/';

export const FALLBACK_COMMON_FONT_FAMILIES = {
    domestic: 'AlibabaPuHuiTi-Regular',
    international: 'Poppins-Regular',
} as const;

export const FALLBACK_SCRIPT_FONT_SPECS = [
    { fontFamily: 'AlibabaPuHuiTi-Regular', scripts: ['Hani'] },
    { fontFamily: 'NotoSerifJP-Regular', scripts: ['Hira', 'Kana'] },
    { fontFamily: 'BMHANNAPro', scripts: ['Hang'] },
    { fontFamily: 'K2D-ExtraLightItalic', scripts: ['Thai'] },
    // { fontFamily: 'NotoSansArabic-Regular', scripts: ['Arab'] },
] as const;
